export const Upload = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 24V28C5 28.5523 5.44772 29 6 29H26C26.5523 29 27 28.5523 27 28V24" stroke="currentColor" stroke-width="2"/>
<path d="M6.69608 12.6984L16.1062 3.40082L25.4256 12.665" stroke="currentColor" stroke-width="2"/>
<path d="M16.1217 23.9584L16.1217 3.95843" stroke="currentColor" stroke-width="2"/>
</svg>`;
